// import { useState } from "react";
// import axios from "axios";
// import { CATEGORY_MAP } from "../json/categoryMap";
// import { DEDUCTION_CONFIG } from "../json/deductionConfig";
// import { apiurl } from "../config/config";

// function AgentComplaintCard({ token }) {
//   const [employeeId, setEmployeeId] = useState("");
//   const [agent, setAgent] = useState(null);
//   const [category, setCategory] = useState("");
//   const [subcategory, setSubcategory] = useState("");
//   const [deduction, setDeduction] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [searching, setSearching] = useState(false);

//   // 🔍 Search Agent
//   const handleSearch = async () => {
//     if (!employeeId.trim()) {
//       alert("Enter Employee Code");
//       return;
//     }

//     try {
//       setSearching(true);

//       const res = await axios.get(
//         `${apiurl}/api/employee/getByEmployeeCode/SUW${employeeId.trim()}`,
//         {
//           headers: { Authorization: token },
//         }
//       );

//       if (res.data.success) {
//         setAgent(res.data.employee);
//       } else {
//         setAgent(null);
//         alert("Employee not found");
//       }
//     } catch (err) {
//       setAgent(null);
//       alert("Employee not found");
//     } finally {
//       setSearching(false);
//     }
//   };

//   // Category Change
//   const handleCategoryChange = (e) => {
//     setCategory(e.target.value);
//     setSubcategory("");
//     setDeduction(0);
//   };

//   // Subcategory Change
//   const handleSubChange = (e) => {
//     const subKey = e.target.value;
//     setSubcategory(subKey);

//     const amount =
//       DEDUCTION_CONFIG?.[category]?.[subKey] || 0;

//     setDeduction(amount);
//   };

//   // Submit Complaint
//   const handleSubmit = async () => {
//     if (!agent || !category || !subcategory) {
//       alert("Fill all required fields");
//       return;
//     }

//     try {
//       setLoading(true);

//       await axios.post(
//         `${apiurl}/api/employee/conduct/create`,
//         {
//           employeeObjId:agent?._id,
//           employeId: agent._id,
//           employeeCode: agent.employeeCode,
//           category,
//           subcategory,
//           deductionAmount: deduction,
//         },
//         {
//           headers: { Authorization: token },
//         }
//       );

//       alert("Complaint lodged successfully");

//       // Reset only category part
//       setCategory("");
//       setSubcategory("");
//       setDeduction(0);

//     } catch (err) {
//       alert(
//         err?.response?.data?.message ||
//         "Failed to lodge complaint"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="bg-white p-6 rounded-xl shadow border space-y-5">

//       <h2 className="text-lg font-semibold">
//         Lodge Agent Complaint
//       </h2>

//       {/* Search */}
//       <div className="flex gap-2">
//         <input
//           type="text"
//           placeholder="Enter Employee Code (e.g. 2894)"
//           value={employeeId}
//           onChange={(e) => setEmployeeId(e.target.value)}
//           className="border rounded px-3 py-2 w-full"
//         />
//         <button
//           onClick={handleSearch}
//           className="bg-blue-600 text-white px-4 rounded"
//         >
//           {searching ? "Searching..." : "Search"}
//         </button>
//       </div>

//       {/* Agent Info */}
//       {agent && (
//         <div className="bg-gray-50 p-4 rounded text-sm border">
//           <p>
//             <b>Name:</b>{" "}
//             {agent.personalDetails.firstName}{" "}
//             {agent.personalDetails.lastName}
//           </p>
//           <p><b>Employee Code:</b> {agent.employeeCode}</p>
//           <p><b>Department:</b> {agent.department}</p>
//           <p><b>Designation:</b> {agent.designation}</p>
//         </div>
//       )}

//       {/* Category */}
//       {agent && (
//         <>
//           <div>
//             <label className="text-sm font-medium">
//               Category
//             </label>
//             <select
//               value={category}
//               onChange={handleCategoryChange}
//               className="w-full border rounded px-3 py-2 mt-1"
//             >
//               <option value="">Select Category</option>
//               {Object.entries(CATEGORY_MAP).map(
//                 ([key, value]) => (
//                   <option key={key} value={key}>
//                     {value.label}
//                   </option>
//                 )
//               )}
//             </select>
//           </div>

//           {/* Subcategory */}
//           {category && (
//             <div>
//               <label className="text-sm font-medium">
//                 Sub Category
//               </label>
//               <select
//                 value={subcategory}
//                 onChange={handleSubChange}
//                 className="w-full border rounded px-3 py-2 mt-1"
//               >
//                 <option value="">
//                   Select Sub Category
//                 </option>
//                 {CATEGORY_MAP[category].subs.map(
//                   (sub) => (
//                     <option
//                       key={sub.key}
//                       value={sub.key}
//                     >
//                       {sub.label}
//                     </option>
//                   )
//                 )}
//               </select>
//             </div>
//           )}

//           {/* Deduction */}
//           {deduction > 0 && (
//             <div className="bg-red-50 border border-red-200 text-red-700 p-3 rounded text-sm">
//               Deduction Amount: ₹{deduction}
//             </div>
//           )}

//           {/* Submit */}
//           {category && subcategory && (
//             <div className="flex justify-end">
//               <button
//                 onClick={handleSubmit}
//                 disabled={loading}
//                 className="bg-red-600 text-white px-4 py-2 rounded"
//               >
//                 {loading
//                   ? "Submitting..."
//                   : "Submit Complaint"}
//               </button>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// }

// export default AgentComplaintCard;

import { useState } from "react";
import axios from "axios";
import { CATEGORY_MAP } from "../json/categoryMap";
import { DEDUCTION_CONFIG } from "../json/deductionConfig";
import { apiurl } from "../config/config";

function AgentComplaintCard({ token,ticket, onDone }) {

    // console.log("ddd",ticket);
  const [employeeId, setEmployeeId] = useState("");
  const [agent, setAgent] = useState(null);
  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [deduction, setDeduction] = useState(0);
  const [severity, setSeverity] = useState("low");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);



  const currentPayrollMonth = new Date().toISOString().slice(0, 7);


  console.log("token",token);

  /* ------------------ Search Agent ------------------ */
  const handleSearch = async () => {
    if (!employeeId.trim()) {
      alert("Enter Employee Code");
      return;
    }

    try {
      setSearching(true);

      const res = await axios.get(
        `${apiurl}/api/employee/getByEmployeeCode/SUW${employeeId.trim()}`,
        { headers: { Authorization: token } }
      );

      if (res.data.success) {
        setAgent(res.data.employee);
      } else {
        setAgent(null);
        alert("Employee not found");
      }
    } catch {
      setAgent(null);
      alert("Employee not found");
    } finally {
      setSearching(false);
    }
  };

  /* ------------------ Category Change ------------------ */
  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
    setSubcategory("");
    setDeduction(0);
  };

  /* ------------------ Subcategory Change ------------------ */
  // const handleSubChange = (e) => {
  //   const subKey = e.target.value;
  //   setSubcategory(subKey);

  //   const amount = DEDUCTION_CONFIG?.[category]?.[subKey] || 0;
  //   setDeduction(amount);
  // };

  const handleSubChange = (e) => {
  const subKey = e.target.value;
  setSubcategory(subKey);

  const amount = DEDUCTION_CONFIG?.[category]?.[subKey] || 0;
  setDeduction(amount);
};


  
  /* ------------------ Submit Complaint ------------------ */
  const handleSubmit = async () => {
    if (!agent || !category || !subcategory) {
      alert("Fill all required fields");
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        `${apiurl}/api/employee/conduct/create`,
        {
          employeeObjId: agent._id,
          employeeId: agent.employeeId,
          employeeCode: agent.employeeCode,
          employeeMasterId: agent.employeeMasterId,
          relatedCSTObjId:ticket?._id,

          category,
          type: "complaint",
          severity,
          order: {
      orderId: ticket?.order?.orderId || null,
      shopifyOrderId: ticket?.order?.shopifyOrderId || null,
    },

          title: `${CATEGORY_MAP[category].label} - ${subcategory}`,
          description,

          hasSalaryDeduction: deduction > 0,
          deductionAmount: deduction,
          payrollMonth: currentPayrollMonth,

          impactScore: severity === "high" ? -10 : severity === "medium" ? -5 : 0,
        },
        { headers: { Authorization: token } }
      );

      alert("Complaint lodged successfully");

      setCategory("");
      setSubcategory("");
      setDeduction(0);
      setDescription("");
      setSeverity("low");

         await onDone();

    } catch (err) {
      alert(err?.response?.data?.message || "Failed to lodge complaint");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow border space-y-5">
      <h2 className="text-lg font-semibold">Lodge Agent Complaint</h2>

      {/* Search */}
      <div className="flex gap-2">
        <input
          type="text"
          placeholder="Enter Employee Code (e.g. 2894)"
          value={employeeId}
          onChange={(e) => setEmployeeId(e.target.value)}
          className="border rounded px-3 py-2 w-full"
        />
        <button
          onClick={handleSearch}
          className="bg-blue-600 text-white px-4 rounded"
        >
          {searching ? "Searching..." : "Search"}
        </button>
      </div>

      {/* Agent Info */}
      {agent && (
        <div className="bg-gray-50 p-4 rounded text-sm border">
          <p>
            <b>Name:</b>{" "}
            {agent.personalDetails?.firstName}{" "}
            {agent.personalDetails?.lastName}
          </p>
          <p><b>Employee Code:</b> {agent.employeeCode}</p>
          <p><b>Department:</b> {agent.department}</p>
          <p><b>Designation:</b> {agent.designation}</p>
        </div>
      )}

      {agent && (
        <>
          {/* Category */}
          <div>
            <label className="text-sm font-medium">Category</label>
            <select
              value={category}
              onChange={handleCategoryChange}
              className="w-full border rounded px-3 py-2 mt-1"
            >
              <option value="">Select Category</option>
              {Object.entries(CATEGORY_MAP).map(([key, value]) => (
                <option key={key} value={key}>
                  {value.label}
                </option>
              ))}
            </select>
          </div>

          {/* Subcategory */}
          {category && (
            <div>
              <label className="text-sm font-medium">Sub Category</label>
              <select
                value={subcategory}
                onChange={handleSubChange}
                className="w-full border rounded px-3 py-2 mt-1"
              >
                <option value="">Select Sub Category</option>
                {CATEGORY_MAP[category].subs.map((sub) => (
                  <option key={sub.key} value={sub.key}>
                    {sub.label}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Severity */}
          {subcategory && (
            <div>
              <label className="text-sm font-medium">Severity</label>
              <select
                value={severity}
                onChange={(e) => setSeverity(e.target.value)}
                className="w-full border rounded px-3 py-2 mt-1"
              >
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
                <option value="critical">Critical</option>
              </select>
            </div>
          )}

          {/* Description */}
          {subcategory && (
            <div>
              <label className="text-sm font-medium">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full border rounded px-3 py-2 mt-1"
                rows={3}
                placeholder="Enter details..."
              />
            </div>
          )}


          {/* Deduction (Auto + Manual Edit) */}
{subcategory && (
  <div>
    <label className="text-sm font-medium">
      Deduction Amount (Editable)
    </label>

    <input
      type="number"
      value={deduction}
      onChange={(e) => setDeduction(Number(e.target.value))}
      className="w-full border rounded px-3 py-2 mt-1"
      placeholder="Enter deduction amount"
    />

    <p className="text-xs text-gray-500 mt-1">
      Auto-filled from rules, but you can modify it manually.
    </p>
  </div>
)}


          {/* Deduction */}
          {deduction > 0 && (
            <div className="bg-red-50 border border-red-200 text-red-700 p-3 rounded text-sm">
              Deduction Amount: ₹{deduction}
            </div>
          )}

          {/* Submit */}
          {subcategory && (
            <div className="flex justify-end">
              <button
                onClick={handleSubmit}
                disabled={loading}
                className="bg-red-600 text-white px-4 py-2 rounded"
              >
                {loading ? "Submitting..." : "Submit Complaint"}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default AgentComplaintCard;